import { render, staticRenderFns } from "./AlertView.vue?vue&type=template&id=b02a63bc&scoped=true"
import script from "./AlertView.vue?vue&type=script&lang=js"
export * from "./AlertView.vue?vue&type=script&lang=js"
import style0 from "./AlertView.vue?vue&type=style&index=0&id=b02a63bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b02a63bc",
  null
  
)

export default component.exports